import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WS_URL =
  `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

export const MOTIFS = [
  "Rendez-vous",
  "Livraison",
  "Entretien/maintenance",
  "Visite technique",
  "Entrevue",
  "Autre",
];

const http = axios.create({ baseURL: API });

const TOKEN_KEY = "ssg_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const authLogin = async (email, password) => {
  const { data } = await http.post("/auth/login", { email, password });
  return data;
};
export const authMe = async () => {
  const { data } = await http.get("/auth/me");
  return data;
};
export const changePassword = async (oldPw, newPw) => {
  const { data } = await http.post("/auth/change-password", { old: oldPw, new: newPw });
  return data;
};
export const fetchUsers = async () => (await http.get("/admin/users")).data;
export const createUser = async (payload) => (await http.post("/admin/users", payload)).data;
export const deleteUserApi = async (id) => (await http.delete(`/admin/users/${id}`)).data;

export const fetchSites = async () => (await http.get("/sites")).data;
export const createSite = async (payload) => (await http.post("/admin/sites", payload)).data;
export const updateSite = async (id, payload) => (await http.put(`/admin/sites/${id}`, payload)).data;
export const deleteSiteApi = async (id) => (await http.delete(`/admin/sites/${id}`)).data;

export const fetchLists = async () => (await http.get("/lists")).data;
export const updateLists = async (payload) => (await http.put("/admin/lists", payload)).data;

export const fetchVisitors = async (params) => {
  const { data } = await http.get("/visitors", { params });
  return data;
};

export const fetchStats = async (params) => {
  const { data } = await http.get("/stats", { params });
  return data;
};

export const createVisitor = async (payload) => {
  const { data } = await http.post("/visitors", payload);
  return data;
};

export const departVisitor = async (id) => {
  const { data } = await http.post(`/visitors/${id}/depart`);
  return data;
};

export const updateVisitor = async (id, payload) => {
  const { data } = await http.put(`/visitors/${id}`, payload);
  return data;
};

export const deleteVisitor = async (id) => {
  const { data } = await http.delete(`/visitors/${id}`);
  return data;
};

export const fetchMonthlyReport = async (month, siteId) => {
  const params = { month };
  if (siteId) params.site_id = siteId;
  const { data } = await http.get("/report/monthly", { params });
  return data;
};

export const fetchTrends = async (months = 6, siteId) => {
  const params = { months };
  if (siteId) params.site_id = siteId;
  const { data } = await http.get("/report/trends", { params });
  return data;
};

export const exportCsvUrl = (params) => {
  const q = new URLSearchParams(params).toString();
  return `${API}/export/csv?${q}`;
};
